var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconIonicIosCheckmarkCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 54.297,
  height: 54.297,
  viewBox: "0 0 54.297 54.297"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Icon_ionic-ios-checkmark-circle",
  "data-name": "Icon ionic-ios-checkmark-circle",
  d: "M30.523,3.375A27.148,27.148,0,1,0,57.672,30.523,27.144,27.144,0,0,0,30.523,3.375Zm13.9,19.643L26.973,40.547H26.96a2.357,2.357,0,0,1-1.514.718,2.285,2.285,0,0,1-1.527-.744L16.61,33.212a.52.52,0,0,1,0-.744l2.323-2.323a.5.5,0,0,1,.731,0l5.8,5.8L41.383,19.9a.515.515,0,0,1,.365-.157h0a.474.474,0,0,1,.365.157L44.4,22.261A.515.515,0,0,1,44.424,23.018Z",
  transform: "translate(-3.375 -3.375)",
  fill: "#35d484"
})));
export { SvgIconIonicIosCheckmarkCircle as ReactComponent };
export default __webpack_public_path__ + "static/media/Icon ionic-ios-checkmark-circle.0cf80a912dc8203f664b1847678c342b.svg";